import { createSlice } from '@reduxjs/toolkit';
import { PURGE } from 'redux-persist/src/constants';
import requestStatus from 'common/constants/status';
import { trashed } from 'common/constants/options';

const initialFiltersState = {
  created_at: {
    start_date: null,
    end_date: null
  },
  language: [],
  search: '',
  soft_delete: trashed.without
};

const initialState = {
  data: {
    currentNews: null,
    news: [],
    search: []
  },
  filters: initialFiltersState,
  pagination: {
    first: 20,
    page: 1
  },
  paginatorInfo: {
    hasMorePages: false,
    lastPage: 0,
    total: 0
  },
  refresh: false,
  status: {
    general: requestStatus.idle,
    search: requestStatus.idle
  }
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    clearSearchResults(state) {
      state.data.search = initialState.data.search;
    },
    create(state) {
      state.status.general = requestStatus.loading;
    },
    createSuccess(state) {
      state.status.general = requestStatus.success;
    },
    createError(state) {
      state.status.general = requestStatus.error;
    },
    find(state) {
      state.status.general = requestStatus.loading;
    },
    findSuccess(state, action) {
      state.status.general = requestStatus.success;
      state.data.currentNews = action.payload;
    },
    findError(state) {
      state.status.general = requestStatus.error;
    },
    forceDelete(state) {
      state.status.general = requestStatus.loading;
    },
    forceDeleteSuccess(state) {
      state.status.general = requestStatus.success;
      state.refresh = true;
    },
    forceDeleteError(state) {
      state.status.general = requestStatus.error;
    },
    list(state) {
      state.status.general = requestStatus.loading;
      if (state.refresh) state.refresh = false;
    },
    listSuccess(state, action) {
      state.status.general = requestStatus.success;
      state.data.news = action.payload;
    },
    listError(state) {
      state.status.general = requestStatus.error;
    },
    remove(state) {
      state.status.general = requestStatus.loading;
    },
    removeSuccess(state) {
      state.status.general = requestStatus.success;
      state.refresh = true;
    },
    removeError(state) {
      state.status.general = requestStatus.error;
    },
    restore(state) {
      state.status.general = requestStatus.loading;
    },
    restoreSuccess(state) {
      state.status.general = requestStatus.success;
      state.refresh = true;
    },
    restoreError(state) {
      state.status.general = requestStatus.error;
    },
    resetFilters(state) {
      state.filters = initialFiltersState;
    },
    search(state) {
      state.status.search = requestStatus.loading;
    },
    searchSuccess(state, action) {
      state.status.search = requestStatus.success;
      state.data.search = action.payload;
    },
    searchError(state) {
      state.status.search = requestStatus.error;
    },
    update(state) {
      state.status.general = requestStatus.loading;
    },
    updateSuccess(state) {
      state.status.general = requestStatus.success;
    },
    updateError(state) {
      state.status.general = requestStatus.error;
    },
    updateFilters(state, action) {
      state.filters = action.payload;
    },
    updatePagination(state, action) {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    updatePaginatorInfo(state, action) {
      state.paginatorInfo = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  }
});

export default newsSlice;
